module.exports = __webpack_public_path__ + "img/tsg-162x230.bac6035a.jpg";